import { createAction, props } from '@ngrx/store';
import { ILocationContext } from '../../../../model/location-context';
import {
    IMaintenanceCommandContext,
    IMaintenanceComponent,
    IMaintenanceContext,
    IMaintenanceFailedTest,
    IMaintenanceLink,
    IMaintenanceModeContext,
    IMaintenanceScheduleItem,
    IMaintenanceTaskCompleted
} from '../../../../model/maintenance';
import { ICommandContext } from './../../../../model/docking';

// Maintenance Context
export const requestMaintenanceContext = createAction(
    '[Maintenance] Request Maintenance Context',
    props<{ locationContext: ILocationContext; deviceId: string }>()
);
export const loadMaintenanceContext = createAction(
    '[Maintenance] Load Maintenance Context',
    props<{ maintenanceContext: IMaintenanceContext }>()
);
export const triggerTestCommand = createAction(
    '[Maintenance] Trigger Test Command',
    props<{ commandContext: ICommandContext; deviceId: string; operator: string }>()
);

// Maintenance Mode
export const setMaintenanceMode = createAction(
    '[Maintenance] set Maintenance Mode',
    props<{ maintenanceModeContext: IMaintenanceModeContext }>()
);

// Context
export const requestMaintenanceModeContext = createAction(
    '[Maintenance] Request Maintenance Mode Context',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceModeContext = createAction(
    '[Maintenance] Load Maintenance Mode Context',
    props<{ maintenanceModeContext: IMaintenanceModeContext }>()
);

// Links
export const requestMaintenanceLinks = createAction(
    '[Maintenance] Request Maintenance Links',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceLinks = createAction(
    '[Maintenance] Load Maintenance Links',
    props<{ maintenanceLinks: IMaintenanceLink[] }>()
);

// Commands
export const requestMaintenanceCommands = createAction(
    '[Maintenance] Request Maintenance Commands',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceCommands = createAction(
    '[Maintenance] Load Maintenance Commands',
    props<{ maintenanceCommands: string[] }>()
);

export const triggerMaintenanceCommand = createAction(
    '[Maintenance] Trigger Command',
    props<{ maintenanceCommandContext: IMaintenanceCommandContext }>()
);

// Failed Tests
export const requestMaintenanceFailedTests = createAction(
    '[Maintenance] Request Maintenance Failed Tests',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceFailedTests = createAction(
    '[Maintenance] Load Maintenance Failed Tests',
    props<{ maintenanceFailedTests: IMaintenanceFailedTest[] }>()
);

// Components
export const requestMaintenanceComponents = createAction(
    '[Maintenance] Request Maintenance Components',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceComponents = createAction(
    '[Maintenance] Load Maintenance Components',
    props<{ maintenanceComponents: IMaintenanceComponent[] }>()
);

// Schedule
export const requestMaintenanceSchedule = createAction(
    '[Maintenance] Request Maintenance Schedule',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceSchedule = createAction(
    '[Maintenance] Load Maintenance Schedule',
    props<{ maintenanceSchedule: IMaintenanceScheduleItem[] }>()
);

// Tasks Completed
export const requestMaintenanceTasksCompleted = createAction(
    '[Maintenance] Request Maintenance Tasks Completed',
    props<{ locationContext: ILocationContext }>()
);

export const loadMaintenanceTasksCompleted = createAction(
    '[Maintenance] Load Maintenance Tasks Completed',
    props<{ maintenanceTasksCompleted: IMaintenanceTaskCompleted[] }>()
);

export const addMaintenanceTaskCompleted = createAction(
    '[Maintenance] Add Maintenance Task Completed',
    props<{ locationContext: ILocationContext; maintenanceTaskCompleted: IMaintenanceTaskCompleted }>()
);
